import { render, staticRenderFns } from "./editFullFift.vue?vue&type=template&id=64ebf0bb&scoped=true&"
import script from "./editFullFift.vue?vue&type=script&lang=js&"
export * from "./editFullFift.vue?vue&type=script&lang=js&"
import style0 from "./editFullFift.vue?vue&type=style&index=0&id=64ebf0bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ebf0bb",
  null
  
)

component.options.__file = "editFullFift.vue"
export default component.exports